import { mixed, object, string } from "yup";

import { draftValidationSchema, titleValidationSchema } from "@dzambalaorg/yup-rules";
import { AchievementRuleStatus, ContractEventType } from "@framework/types";
import { reISO8601 } from "@dzambalaorg/constants";

export const achievementRuleValidationSchema = object().shape({
  title: titleValidationSchema,
  description: draftValidationSchema,
  achievementStatus: mixed<AchievementRuleStatus>()
    .oneOf(Object.values(AchievementRuleStatus))
    .required("form.validations.valueMissing"),
  eventType: mixed<ContractEventType>()
    .oneOf(Object.values(ContractEventType))
    .required("form.validations.valueMissing"),
  // contractId: dbIdValidationSchema,
  startTimestamp: string()
    .matches(reISO8601, "form.validations.patternMismatch")
    .required("form.validations.valueMissing"),
  endTimestamp: string()
    .matches(reISO8601, "form.validations.patternMismatch")
    .required("form.validations.valueMissing"),
});
